import { ICON_COLOR } from '@zep-us/zus';
import { logger } from '@zep/core-logger';
import type { AvatarData } from '@/api/gen/_model/avatarData';
import { ChevronRightIcon } from '@/icons';
import { UserAvatar } from '@/shared/features/user-avatar';
import { useOpenUserProfile } from '@/shared/hooks/useOpenUserProfile';
import { cn } from '@/utils/tailwind.util';
type AuthorInfoProps = {
  username: string;
  authorId: string;
  avatarData?: AvatarData | null;
  className?: string;
};
export const AuthorInfo = ({
  username,
  authorId,
  avatarData,
  className
}: AuthorInfoProps) => {
  const openUserProfile = useOpenUserProfile();
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    logger.track('click_user_profile');
    openUserProfile(authorId);
  };
  return <div className={cn('flex cursor-pointer items-center gap-2xs group/author', className)} onClick={handleClick} data-sentry-component="AuthorInfo" data-sentry-source-file="AuthorInfo.tsx">
      <UserAvatar avatarData={avatarData} size="sm" data-sentry-element="UserAvatar" data-sentry-source-file="AuthorInfo.tsx" />
      <div className="flex items-center gap-4xs">
        <p className="text-body-md-semibold text-neutral group-hover/author:text-assistive">
          {username}
        </p>
        <ChevronRightIcon size={'xs'} fill={ICON_COLOR.neutral} data-sentry-element="ChevronRightIcon" data-sentry-source-file="AuthorInfo.tsx" />
      </div>
    </div>;
};